import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import "./Home.css";

const API =
  process.env.REACT_APP_API_URL || "https://backend-9i6n.onrender.com";

const M_MONTHS = ["जाने", "फेब्रु", "मार्च", "एप्रिल", "मे", "जून", "जुलै", "ऑग", "सप्टें", "ऑक्टो", "नोव्हें", "डिसें"];
const DEVANAGARI = ["०", "१", "२", "३", "४", "५", "६", "७", "८", "९"];
const toDev = (n) => String(n).replace(/\d/g, (d) => DEVANAGARI[d]);

/* stats band — falls back to these until admin-managed village data loads */
const DEFAULT_STATS = [
  { value: "४,८५०", label: "एकूण लोकसंख्या" },
  { value: "१,१२०", label: "एकूण कुटुंबे" },
  { value: "९", label: "प्रभाग (वॉर्ड)" },
  { value: "८४%", label: "साक्षरता दर" },
];

/* build the stats band from admin-managed village data (गावाची माहिती) */
const hasVal = (n) => n !== null && n !== undefined && n !== "";
const buildStats = (v) => {
  if (!v) return DEFAULT_STATS;
  const num = (n) => toDev(Number(n).toLocaleString("en-IN"));
  return [
    { value: hasVal(v.populationTotal) ? num(v.populationTotal) : DEFAULT_STATS[0].value, label: "एकूण लोकसंख्या" },
    { value: hasVal(v.totalFamilies) ? num(v.totalFamilies) : DEFAULT_STATS[1].value, label: "एकूण कुटुंबे" },
    { value: hasVal(v.wards) ? toDev(v.wards) : DEFAULT_STATS[2].value, label: "प्रभाग (वॉर्ड)" },
    { value: hasVal(v.literacyRate) ? toDev(v.literacyRate) + "%" : DEFAULT_STATS[3].value, label: "साक्षरता दर" },
  ];
};

/* ---- static design content ---- */
const SERVICES = [
  { title: "जन्म प्रमाणपत्र", description: "नवजात बालकाच्या जन्माची अधिकृत नोंद व प्रमाणपत्र मिळवा.", icon: "M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z", tint: "#E8F3EA", ink: "#0F5C2E" },
  { title: "मृत्यू प्रमाणपत्र", description: "अधिकृत नोंदींसाठी मृत्यू प्रमाणपत्रासाठी अर्ज करा.", icon: "M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z", tint: "#E7F0F8", ink: "#1466A8" },
  { title: "उत्पन्न प्रमाणपत्र", description: "शासकीय योजना व शिक्षणासाठी उत्पन्नाचा पुरावा.", icon: "M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z", tint: "#FBF0E0", ink: "#C06A12" },
  { title: "रहिवासी प्रमाणपत्र", description: "शासकीय सेवांसाठी रहिवासाचा अधिकृत पुरावा.", icon: "M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6", tint: "#E8F3EA", ink: "#0F5C2E" },
  { title: "विवाह प्रमाणपत्र", description: "कायदेशीर विवाह नोंदणी व प्रमाणपत्रासाठी अर्ज करा.", icon: "M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z", tint: "#F8E9EC", ink: "#B23A55" },
  { title: "मालमत्ता कर", description: "घरपट्टी व मालमत्ता कराचा ऑनलाइन भरणा करा.", icon: "M17 9V7a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2m2 4h10a2 2 0 002-2v-6a2 2 0 00-2-2H9a2 2 0 00-2 2v6a2 2 0 002 2zm7-5a2 2 0 11-4 0 2 2 0 014 0z", tint: "#E7F0F8", ink: "#1466A8" },
];

const TICKER = [
  "📌 ग्रामसभा — रविवार, दुपारी १२:०० वा. समाजमंदिर येथे",
  "💧 पाणीपुरवठा दुरुस्ती : शुक्रवारी सकाळी पाणी बंद राहील",
  "🧾 मालमत्ता कर भरणा अंतिम तारीख : ३१ मार्च",
];

const SAMPLE_NOTICES = [
  { day: "१८", month: "जुलै", tag: "ग्रामसभा", color: "#0F5C2E", tint: "#E8F3EA", title: "मासिक ग्रामसभेचे आयोजन — समाजमंदिर येथे दुपारी १२ वा.", isNew: true },
  { day: "१२", month: "जुलै", tag: "पाणीपुरवठा", color: "#1466A8", tint: "#E7F0F8", title: "नळ दुरुस्तीमुळे शुक्रवारी सकाळी पाणीपुरवठा बंद राहील.", isNew: true },
  { day: "०५", month: "जुलै", tag: "कर भरणा", color: "#C06A12", tint: "#FBF0E0", title: "मालमत्ता कर भरण्याची अंतिम तारीख ३१ जुलै — विलंब शुल्क टाळा.", isNew: false },
  { day: "२८", month: "जून", tag: "आरोग्य", color: "#B23A55", tint: "#F8E9EC", title: "मोफत लसीकरण व आरोग्य तपासणी शिबिर — प्राथमिक आरोग्य केंद्र.", isNew: false },
];

const SAMPLE_SCHEMES = [
  { title: "प्रधानमंत्री आवास योजना", short: "ग्रामीण भागातील बेघर कुटुंबांना पक्के घर बांधण्यासाठी अनुदान.", dept: "ग्रामविकास विभाग" },
  { title: "महात्मा गांधी रोजगार हमी (मनरेगा)", short: "प्रत्येक कुटुंबाला वर्षातून १०० दिवसांचा हमखास रोजगार.", dept: "रोजगार हमी विभाग" },
  { title: "स्वच्छ भारत — शौचालय अनुदान", short: "वैयक्तिक शौचालय बांधकामासाठी आर्थिक सहाय्य.", dept: "पाणी व स्वच्छता विभाग" },
  { title: "संजय गांधी निराधार योजना", short: "निराधार, वृद्ध व विधवा नागरिकांना मासिक निवृत्तीवेतन.", dept: "समाजकल्याण विभाग" },
];

const NOTICE_PALETTE = [
  { color: "#0F5C2E", tint: "#E8F3EA" },
  { color: "#1466A8", tint: "#E7F0F8" },
  { color: "#C06A12", tint: "#FBF0E0" },
  { color: "#B23A55", tint: "#F8E9EC" },
];

const Arrow = ({ w = 18 }) => (
  <svg width={w} height={w} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2"><path strokeLinecap="round" strokeLinejoin="round" d="M13 7l5 5-5 5M5 12h13" /></svg>
);

const Home = () => {
  const navigate = useNavigate();
  const [notices, setNotices] = useState(SAMPLE_NOTICES);
  const [schemes, setSchemes] = useState(SAMPLE_SCHEMES);
  const [gallery, setGallery] = useState([]);
  const [leaders, setLeaders] = useState({ sarpanch: null, upsarpanch: null });
  const [stats, setStats] = useState(DEFAULT_STATS);

  useEffect(() => {
    window.scrollTo(0, 0);

    axios.get(`${API}/api/notices`).then((res) => {
      if (Array.isArray(res.data) && res.data.length) {
        setNotices(
          res.data.slice(0, 4).map((n, i) => {
            const d = n.createdAt ? new Date(n.createdAt) : new Date();
            const pal = NOTICE_PALETTE[i % NOTICE_PALETTE.length];
            return {
              day: toDev(String(d.getDate()).padStart(2, "0")),
              month: M_MONTHS[d.getMonth()],
              tag: n.isImportant ? "महत्त्वाचे" : "सूचना",
              title: n.title,
              isNew: i < 2,
              color: pal.color,
              tint: pal.tint,
            };
          })
        );
      }
    }).catch(() => {});

    axios.get(`${API}/api/schemes`).then((res) => {
      if (Array.isArray(res.data) && res.data.length) {
        setSchemes(
          res.data.slice(0, 4).map((s) => ({
            title: s.title,
            short: s.description || s.benefits || "",
            dept: s.schemeType === "Central" ? "केंद्र शासन" : "राज्य शासन",
          }))
        );
      }
    }).catch(() => {});

    axios.get(`${API}/api/gallery`).then((res) => {
      if (Array.isArray(res.data)) setGallery(res.data.slice(0, 5));
    }).catch(() => {});

    // गावाची माहिती → stats band (लोकसंख्या / कुटुंबे / प्रभाग / साक्षरता दर)
    axios.get(`${API}/api/village`).then((res) => {
      if (res.data) setStats(buildStats(res.data));
    }).catch(() => {});

    axios.get(`${API}/api/contacts`).then((res) => {
      if (Array.isArray(res.data)) {
        // normalize role: lowercase + strip spaces/hyphens/underscores/dots
        const norm = (m) => (m.role || "").toLowerCase().replace(/[\s\-_.]/g, "");
        const hasSarpanch = (r) => r.includes("sarpanch") || r.includes("सरपंच");
        // उप-सरपंच / Upa-Sarpanch / Up Sarpanch / Deputy Sarpanch.
        // Must be checked FIRST: "उपसरपंच" contains "सरपंच" and "upasarpanch" contains "sarpanch".
        const isUp = (m) => {
          const r = norm(m);
          return (
            hasSarpanch(r) &&
            (r.includes("up") || r.includes("उप") || r.includes("deputy") || r.includes("dy"))
          );
        };
        const isSarpanch = (m) => hasSarpanch(norm(m)) && !isUp(m);
        setLeaders({
          sarpanch: res.data.find(isSarpanch) || null,
          upsarpanch: res.data.find(isUp) || null,
        });
      }
    }).catch(() => {});
  }, []);

  const leaderCard = (person, fallbackName, roleLabel, roleColor, roleTint) => (
    <div style={{ textAlign: "center" }}>
      <div style={{ width: 104, height: 104, margin: "0 auto", borderRadius: "50%", padding: 3, background: `linear-gradient(135deg,${roleColor},#1466A8)` }}>
        <img
          src={person?.photo || "https://cdn-icons-png.flaticon.com/512/149/149071.png"}
          alt={roleLabel}
          style={{ width: "100%", height: "100%", borderRadius: "50%", objectFit: "cover", background: "#fff" }}
          onError={(e) => { e.target.src = "https://cdn-icons-png.flaticon.com/512/149/149071.png"; }}
        />
      </div>
      <div style={{ fontWeight: 700, fontSize: 16, marginTop: 12, color: "#17241C" }}>{person?.name || fallbackName}</div>
      <div style={{ fontSize: 13.5, color: roleColor, fontWeight: 600, background: roleTint, display: "inline-block", padding: "2px 12px", borderRadius: 100, marginTop: 5 }}>{roleLabel}</div>
    </div>
  );

  /* hero ticker — real notice titles (सूचना शीर्षक) from the fetched
     `notices` list; falls back to the static strings only if none loaded */
  const tickerItems =
    notices.length > 0
      ? notices.map((n) => `${n.isImportant || n.tag === "महत्त्वाचे" ? "⚠️" : "📌"} ${n.title}`)
      : TICKER;

  return (
    <div>
      {/* ===== HERO ===== */}
      <section style={{ position: "relative", overflow: "hidden", background: "#0F5C2E" }}>
        <div style={{ position: "absolute", inset: 0 }}>
          <img src="https://images.unsplash.com/photo-1595877244574-e90ce41ce089?w=1600&q=80" alt="रोषणखेडा" style={{ width: "100%", height: "100%", objectFit: "cover" }} />
        </div>
        <div style={{ position: "absolute", inset: 0, background: "linear-gradient(100deg,rgba(11,50,26,.94) 0%,rgba(15,92,46,.82) 42%,rgba(15,92,46,.35) 100%)" }} />
        <div className="rk-hero-grid">
          <div>
            <div style={{ display: "inline-flex", alignItems: "center", gap: 8, background: "rgba(255,255,255,.14)", border: "1px solid rgba(255,255,255,.28)", color: "#eafaee", padding: "7px 15px", borderRadius: 100, fontSize: 13.5, fontWeight: 600 }}>
              <span style={{ width: 7, height: 7, borderRadius: "50%", background: "#7ee397", boxShadow: "0 0 0 3px rgba(126,227,151,.3)" }} />
              अधिकृत ग्रामपंचायत पोर्टल
            </div>
            <h1 style={{ fontFamily: "var(--rk-serif)", fontWeight: 800, color: "#fff", fontSize: 52, lineHeight: 1.12, margin: "20px 0 0", textShadow: "0 2px 20px rgba(0,0,0,.2)" }}>
              डिजिटल ग्रामपंचायत<br /><span style={{ color: "#a7e8b6" }}>रोषणखेडा</span>
            </h1>
            <p style={{ color: "#e4f2e7", fontSize: 18, lineHeight: 1.65, margin: "20px 0 0", maxWidth: 560 }}>
              पारदर्शक प्रशासन, आधुनिक तंत्रज्ञान आणि नागरिकाभिमुख सेवा — रोषणखेडा ग्रामपंचायतीच्या अधिकृत पोर्टलवर आपले मनःपूर्वक स्वागत आहे.
            </p>
            <div style={{ display: "flex", gap: 14, marginTop: 30, flexWrap: "wrap" }}>
              <button className="rk-btn-white" onClick={() => navigate("/services")}>
                सेवेसाठी अर्ज करा <Arrow />
              </button>
              <button className="rk-btn-ghost" onClick={() => navigate("/notices")}>ताज्या सूचना पहा</button>
            </div>
          </div>

          <div className="rk-leader-card">
            <div style={{ fontFamily: "var(--rk-serif)", fontWeight: 700, fontSize: 18, color: "#0F5C2E", textAlign: "center" }}>आपले नेतृत्व</div>
            <div style={{ width: 44, height: 3, background: "#E8871E", borderRadius: 2, margin: "8px auto 20px" }} />
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 16 }}>
              {leaderCard(leaders.sarpanch, "श्री. —", "सरपंच", "#0F5C2E", "#E8F3EA")}
              {leaderCard(leaders.upsarpanch, "श्री. —", "उपसरपंच", "#1466A8", "#E7F0F8")}
            </div>
            <button onClick={() => navigate("/contact")} style={{ width: "100%", marginTop: 18, background: "#F0F5EE", color: "#0F5C2E", border: "1px solid #d9e7db", borderRadius: 9, padding: 11, fontFamily: "inherit", fontWeight: 600, fontSize: 14.5, cursor: "pointer" }}>सर्व सदस्य पहा →</button>
          </div>
        </div>

        {/* ticker */}
        <div style={{ position: "relative", background: "rgba(0,0,0,.28)", borderTop: "1px solid rgba(255,255,255,.12)", overflow: "hidden" }}>
          <div style={{ maxWidth: 1240, margin: "0 auto", display: "flex", alignItems: "center" }}>
            <div style={{ background: "#E8871E", color: "#fff", fontWeight: 700, fontSize: 14, padding: "11px 18px", whiteSpace: "nowrap", display: "flex", alignItems: "center", gap: 8, flexShrink: 0, zIndex: 2 }}>
              <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path strokeLinecap="round" strokeLinejoin="round" d="M15 17h5l-1.4-1.4A2 2 0 0118 14.2V11a6 6 0 10-12 0v3.2a2 2 0 01-.6 1.4L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9" /></svg>
              ताज्या सूचना
            </div>
            <div style={{ overflow: "hidden", flex: 1, padding: "0 16px" }}>
              <div style={{ display: "inline-flex", gap: 48, whiteSpace: "nowrap", animation: "rkTicker 26s linear infinite", color: "#eafaee", fontSize: 14.5, fontWeight: 500 }}>
                {[...tickerItems, ...tickerItems].map((t, i) => <span key={i}>{t}</span>)}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ===== QUICK SERVICES ===== */}
      <section style={{ maxWidth: 1240, margin: "0 auto", padding: "72px 20px 20px" }}>
        <div style={{ textAlign: "center" }}>
          <div style={{ color: "#E8871E", fontWeight: 700, fontSize: 14, letterSpacing: 1.5, textTransform: "uppercase" }}>ऑनलाइन सेवा</div>
          <h2 style={{ fontFamily: "var(--rk-serif)", fontWeight: 700, fontSize: 34, color: "#17241C", marginTop: 6 }}>घरबसल्या अर्ज करा</h2>
          <p style={{ color: "#5B6B60", fontSize: 16.5, marginTop: 8 }}>विविध प्रमाणपत्रे व सेवांसाठी काही मिनिटांत ऑनलाइन अर्ज करा.</p>
        </div>
        <div className="rk-grid-3" style={{ marginTop: 40 }}>
          {SERVICES.map((s) => (
            <div key={s.title} className="rk-service-card" onClick={() => navigate("/services")}>
              <div style={{ width: 52, height: 52, borderRadius: 13, background: s.tint, display: "flex", alignItems: "center", justifyContent: "center" }}>
                <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke={s.ink} strokeWidth="1.9"><path strokeLinecap="round" strokeLinejoin="round" d={s.icon} /></svg>
              </div>
              <h3 style={{ fontWeight: 700, fontSize: 19, marginTop: 18, color: "#17241C" }}>{s.title}</h3>
              <p style={{ color: "#5B6B60", fontSize: 14.5, lineHeight: 1.55, marginTop: 8 }}>{s.description}</p>
              <div style={{ marginTop: 16, color: "#0F5C2E", fontWeight: 700, fontSize: 14.5, display: "flex", alignItems: "center", gap: 6 }}>अर्ज करा <Arrow w={15} /></div>
            </div>
          ))}
        </div>
      </section>

      {/* ===== STATS BAND ===== */}
      <section style={{ maxWidth: 1240, margin: "56px auto 0", padding: "0 20px" }}>
        <div className="rk-stats-band">
          {stats.map((st) => (
            <div key={st.label} className="rk-stat">
              <div style={{ fontFamily: "var(--rk-serif)", fontWeight: 800, fontSize: 38, color: "#fff", lineHeight: 1 }}>{st.value}</div>
              <div style={{ color: "#bfe3c8", fontSize: 15, marginTop: 8, fontWeight: 500 }}>{st.label}</div>
            </div>
          ))}
        </div>
      </section>

      {/* ===== NOTICES + SCHEMES ===== */}
      <section className="rk-grid-2" style={{ maxWidth: 1240, margin: "0 auto", padding: "72px 20px 0" }}>
        <div>
          <div style={{ display: "flex", alignItems: "flex-end", justifyContent: "space-between", marginBottom: 20 }}>
            <div>
              <div style={{ color: "#E8871E", fontWeight: 700, fontSize: 13.5, letterSpacing: 1.5, textTransform: "uppercase" }}>सूचना फलक</div>
              <h2 style={{ fontFamily: "var(--rk-serif)", fontWeight: 700, fontSize: 28, color: "#17241C" }}>ताज्या सूचना</h2>
            </div>
            <button className="rk-link-btn" onClick={() => navigate("/notices")}>सर्व पहा →</button>
          </div>
          <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
            {notices.map((n, i) => (
              <div key={i} className="rk-notice-row" style={{ borderLeft: `4px solid ${n.color}` }}>
                <div style={{ textAlign: "center", background: "#F0F5EE", borderRadius: 9, padding: "8px 12px", flexShrink: 0, minWidth: 58 }}>
                  <div style={{ fontWeight: 800, fontSize: 20, color: "#0F5C2E", lineHeight: 1 }}>{n.day}</div>
                  <div style={{ fontSize: 12, color: "#5B6B60" }}>{n.month}</div>
                </div>
                <div style={{ flex: 1 }}>
                  <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                    <span style={{ fontSize: 11.5, fontWeight: 700, color: n.color, background: n.tint, padding: "2px 9px", borderRadius: 100 }}>{n.tag}</span>
                    {n.isNew && <span style={{ fontSize: 11, fontWeight: 700, color: "#fff", background: "#E8871E", padding: "2px 8px", borderRadius: 100 }}>नवीन</span>}
                  </div>
                  <div style={{ fontWeight: 600, fontSize: 16, marginTop: 5, color: "#17241C" }}>{n.title}</div>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div>
          <div style={{ display: "flex", alignItems: "flex-end", justifyContent: "space-between", marginBottom: 20 }}>
            <div>
              <div style={{ color: "#E8871E", fontWeight: 700, fontSize: 13.5, letterSpacing: 1.5, textTransform: "uppercase" }}>कल्याणकारी</div>
              <h2 style={{ fontFamily: "var(--rk-serif)", fontWeight: 700, fontSize: 28, color: "#17241C" }}>शासकीय योजना</h2>
            </div>
            <button className="rk-link-btn" onClick={() => navigate("/schemes")}>सर्व पहा →</button>
          </div>
          <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
            {schemes.map((sc, i) => (
              <div key={i} className="rk-scheme-row" onClick={() => navigate("/schemes")}>
                <div style={{ fontWeight: 700, fontSize: 16.5, color: "#17241C" }}>{sc.title}</div>
                <div style={{ fontSize: 13.5, color: "#5B6B60", marginTop: 4, lineHeight: 1.5 }}>{sc.short}</div>
                <div style={{ fontSize: 12.5, color: "#1466A8", fontWeight: 600, marginTop: 8 }}>{sc.dept}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ===== GALLERY PREVIEW ===== */}
      <section style={{ maxWidth: 1240, margin: "0 auto", padding: "72px 20px 0" }}>
        <div style={{ display: "flex", alignItems: "flex-end", justifyContent: "space-between", marginBottom: 24, flexWrap: "wrap", gap: 10 }}>
          <div>
            <div style={{ color: "#E8871E", fontWeight: 700, fontSize: 13.5, letterSpacing: 1.5, textTransform: "uppercase" }}>क्षणचित्रे</div>
            <h2 style={{ fontFamily: "var(--rk-serif)", fontWeight: 700, fontSize: 28, color: "#17241C" }}>गावातील छायाचित्रे</h2>
          </div>
          <button className="rk-link-btn" onClick={() => navigate("/gallery")}>संपूर्ण गॅलरी →</button>
        </div>
        <div className="rk-gallery-preview">
          {[0, 1, 2, 3, 4].map((idx) => (
            <div key={idx} className={`rk-gal-cell ${idx === 0 ? "rk-gal-big" : ""}`}>
              {gallery[idx] ? (
                <img src={gallery[idx].image} alt={gallery[idx].caption || "गॅलरी"} loading="lazy" />
              ) : (
                <div className="rk-gal-empty">फोटो</div>
              )}
            </div>
          ))}
        </div>
      </section>

      {/* ===== ABOUT STRIP ===== */}
      <section style={{ maxWidth: 1240, margin: "0 auto", padding: "72px 20px 0" }}>
        <div className="rk-grid-2" style={{ alignItems: "center", gap: 44 }}>
          <div style={{ borderRadius: 18, overflow: "hidden", height: 340, boxShadow: "0 20px 44px rgba(15,92,46,.14)" }}>
            <img src="https://images.unsplash.com/photo-1500382017468-9049fed747ef?w=1200&q=80" alt="रोषणखेडा गाव" style={{ width: "100%", height: "100%", objectFit: "cover" }} />
          </div>
          <div>
            <div style={{ color: "#E8871E", fontWeight: 700, fontSize: 13.5, letterSpacing: 1.5, textTransform: "uppercase" }}>आमच्याबद्दल</div>
            <h2 style={{ fontFamily: "var(--rk-serif)", fontWeight: 700, fontSize: 32, color: "#17241C", marginTop: 6 }}>रोषणखेडा गाव</h2>
            <p style={{ color: "#42524a", fontSize: 16, lineHeight: 1.7, marginTop: 14 }}>
              रोषणखेडा हे नंदुरबार जिल्ह्यातील शहादा तालुक्यातील एक प्रगतिशील गाव आहे. शेती, दुग्धव्यवसाय आणि सहकार यांवर आधारित अर्थव्यवस्था असलेल्या या गावाने डिजिटल प्रशासनाच्या दिशेने महत्त्वाची पावले उचलली आहेत.
            </p>
            <div style={{ display: "flex", flexDirection: "column", gap: 12, marginTop: 22 }}>
              {["पारदर्शक व लोकाभिमुख कारभार", "डिजिटल सेवा व ऑनलाइन अर्ज सुविधा", "शाश्वत ग्रामविकासाची बांधिलकी"].map((t) => (
                <div key={t} style={{ display: "flex", gap: 12, alignItems: "flex-start" }}>
                  <span style={{ color: "#0F5C2E", marginTop: 2 }}><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path strokeLinecap="round" strokeLinejoin="round" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" /></svg></span>
                  <span style={{ color: "#42524a", fontSize: 15.5 }}>{t}</span>
                </div>
              ))}
            </div>
            <button onClick={() => navigate("/about")} style={{ marginTop: 26, background: "#0F5C2E", color: "#fff", border: "none", borderRadius: 9, padding: "13px 26px", fontFamily: "inherit", fontWeight: 700, fontSize: 15.5, cursor: "pointer" }}>गावाची अधिक माहिती →</button>
          </div>
        </div>
      </section>

      {/* ===== CTA ===== */}
      <section style={{ maxWidth: 1240, margin: "76px auto 0", padding: "0 20px" }}>
        <div style={{ background: "linear-gradient(115deg,#0F5C2E,#0b3f22)", borderRadius: 20, padding: "52px 40px", textAlign: "center", position: "relative", overflow: "hidden" }}>
          <div style={{ position: "absolute", top: -40, right: -40, width: 200, height: 200, borderRadius: "50%", background: "rgba(232,135,30,.16)" }} />
          <div style={{ position: "absolute", bottom: -60, left: -30, width: 180, height: 180, borderRadius: "50%", background: "rgba(20,102,168,.2)" }} />
          <div style={{ position: "relative" }}>
            <h2 style={{ fontFamily: "var(--rk-serif)", fontWeight: 700, fontSize: 32, color: "#fff" }}>काही मदत हवी आहे?</h2>
            <p style={{ color: "#cfe6d3", fontSize: 17, marginTop: 10 }}>आमच्या कार्यालयाशी संपर्क साधा किंवा तक्रार नोंदवा — आम्ही आपल्या सेवेसाठी सदैव तत्पर आहोत.</p>
            <div style={{ display: "flex", gap: 14, justifyContent: "center", marginTop: 26, flexWrap: "wrap" }}>
              <button onClick={() => navigate("/contact")} style={{ background: "#fff", color: "#0F5C2E", border: "none", borderRadius: 9, padding: "14px 28px", fontFamily: "inherit", fontWeight: 700, fontSize: 16, cursor: "pointer" }}>संपर्क साधा</button>
              <button onClick={() => navigate("/login")} style={{ background: "rgba(255,255,255,.12)", color: "#fff", border: "1.5px solid rgba(255,255,255,.5)", borderRadius: 9, padding: "14px 28px", fontFamily: "inherit", fontWeight: 600, fontSize: 16, cursor: "pointer" }}>तक्रार नोंदवा</button>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;
